import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { check } from '../../../utils/tokenUtils';
import { getNavigationBackground } from '../../../actions/navigation-background';
import { getLatestNews } from '../../../actions/latest-news';
import { getAdminLinks } from '../../../actions/adminLinks';

import NavbarTopLinks from './navbar-top-links';
import NavbarMainMenu from './navbar-main-menu';

import { Menu, Cancel } from '../../common/icons';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';
import IgniteUkLogoGold from '../../../assets/img/ignite_logo_gold.png';

import './user-navigation.css';

class UserNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false
    };
  }

  handleMenu = () => {
    this.setState({
      menu: !this.state.menu
    });
  }
  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(getNavigationBackground());
    dispatch(getLatestNews());
    dispatch(getAdminLinks());
  }

  render() {
    const { prelogin, postlogin, gold} = this.props;
    const { menu } = this.state;
    const menuIconClassName = gold ? 'navbar-menu navbar-menu-gold' : 'navbar-menu';
    return (
      <Navbar fixedTop fluid>
        <Link to='/'>
          <img src={gold ? IgniteUkLogoGold : IgniteUkLogo} alt="Ignite UK" />
        </Link>
        <div className="navbar-right">
          <div className="nav-desktop-menu-links">
            <NavbarTopLinks gold={gold} search={this.state.search} handleInputChange={this.handleInputChange} />
          </div>
          {this.state.menu ? (
            <Cancel height={24} width={24} className={menuIconClassName} onClick={() => this.handleMenu()} />
          ) : (
            <Menu height={24} width={24} className={menuIconClassName} onClick={() => this.handleMenu()} />
          )}
        </div>
        {menu && (
          <div className="navigation-menu-active" style={{ backgroundImage: check() ? `url(${postlogin})` : `url(${prelogin})` }}>
            <div className="nav-mobile-menu-links">
              <NavbarTopLinks gold={gold} />
            </div>
            <NavbarMainMenu handleMenu={this.handleMenu} />
          </div>
        )}
      </Navbar>
    );
  }
}

const mapStateToProps = state => ({
  prelogin: state.navigationBackground.prelogin,
  postlogin: state.navigationBackground.postlogin
});


export default connect(mapStateToProps)(UserNavigation);



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/user-navigation.jsx